import './styles.css';

import { configureCspNonce, initTheme } from '@saay/ui';
import { AppProviders, createAppRuntime } from '@saay/web-app';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { createAppRouter } from './app.js';
import { createAuth } from './auth.js';
import { env } from './env.js';
import { watchDarkClass } from './theme-class.js';

async function start(): Promise<void> {
  // A stored dark choice is applied before the first render, so it never flashes light.
  initTheme();
  watchDarkClass();
  configureCspNonce();

  if (import.meta.env.DEV && env.useMocks) {
    const { startMocks } = await import('./dev/mocks.js');
    await startMocks(env.apiBaseUrl);
  }

  const runtime = createAppRuntime({ apiBaseUrl: env.apiBaseUrl, auth: await createAuth() });
  const root = document.getElementById('root');
  if (root === null) {
    throw new Error('Missing #root');
  }

  createRoot(root).render(
    <StrictMode>
      <AppProviders appId="admin-web" runtime={runtime}>
        <RouterProvider router={createAppRouter()} />
      </AppProviders>
    </StrictMode>,
  );
}

void start();
